import { Link } from "react-router-dom";
import SansmrutiLogo from '../assets/images/SansmrutiLog.png';


const SansmrutiNavbar = () => {
  return (
    <nav className="bg-[#54a50f] text-white py-4 px-6 flex justify-between items-center shadow-md">
      <div className="flex items-center">
        <img src={SansmrutiLogo} alt="logo" className="h-12 w-12 mr-3" />
        
      </div>
      <ul className="flex gap-6 text-sm font-medium">
        <li><Link to="/TGSH/sansmruti">Home</Link></li>
        <li><Link to="/TGSH/sansmruti/introduction">Introduction</Link></li>
        <li><Link to="/TGSH/sansmruti/book-releases">Book Releases</Link></li>
        <li><Link to="/TGSH/sansmruti/packages">Packages</Link></li>
        <li><Link to="/TGSH/sansmruti/contact">Contact</Link></li>
      </ul>
    </nav>
  );
}
export default SansmrutiNavbar;